import { defineMessage } from "react-intl";

export const messages = {
  login: {
    buttons: {
      signIn: defineMessage({
        defaultMessage: "Zaloguj się",
        id: "kYs7ww",
      }),
    },
  },

  registerConfirmation: {
    notif: {
      success: defineMessage({
        defaultMessage: "Konto zostało aktywowane.",
        id: "vHJqag",
      }),

      error: defineMessage({
        defaultMessage: "Konto nie mogło zostać aktywowane.",
        id: "28JtAB",
      }),
    },
  },

  register: {
    title: defineMessage({ defaultMessage: "Rejestracja", id: "dLEET3" }),

    notif: {
      success: defineMessage({
        defaultMessage:
          "Konto zostało utworzone. Instrukcja aktywacji konta została wysłana na podany adres email",
        id: "qZI0mm",
      }),

      error: defineMessage({
        defaultMessage: "Coś poszło nie tak...",
        id: "U/QucF",
      }),
    },

    form: {
      labels: {
        name: defineMessage({
          defaultMessage: "Imię i nazwisko",
          description: "admin",
          id: "3xQul9",
        }),

        email: defineMessage({
          defaultMessage: "Email",
          id: "sy+pv5",
        }),

        companyName: defineMessage({
          defaultMessage: "Nazwa organizacji",
          id: "l3av/7",
        }),

        password: defineMessage({
          defaultMessage: "Hasło",
          id: "ya1vft",
        }),

        passwordConfirmation: defineMessage({
          defaultMessage: "Potwierdzenie hasła",
          id: "deFGRP",
        }),
      },
    },

    errors: {
      required: defineMessage({
        defaultMessage: "pole wymagane",
        id: "VFRVbl",
      }),

      passwordConfirmation: defineMessage({
        defaultMessage: "potwierdzenie hasła musi się zgadzać z hasłem",
        id: "ZtyZuY",
      }),
    },

    buttons: {
      signUp: defineMessage({
        defaultMessage: "Zarejestruj się",
        id: "ARRFrr",
      }),
    },
  },

  resetPassword: {
    title: defineMessage({ defaultMessage: "Resetuj hasło", id: "m8cjjj" }),

    notif: {
      info: defineMessage({
        defaultMessage: "Podaj swój adres email, żeby zresetować hasło.",
        id: "M+kzUz",
      }),

      success: defineMessage({
        defaultMessage:
          "Instrukcje dotyczące resetu hasła zostały wysłane na podany adres email.",
        id: "k7Jd+5",
      }),
    },

    form: {
      labels: {
        email: defineMessage({ defaultMessage: "Email", id: "sy+pv5" }),
      },
    },

    buttons: {
      resetPassword: defineMessage({
        defaultMessage: "Resetuj hasło",
        id: "m8cjjj",
      }),
    },

    errors: {
      required: defineMessage({
        defaultMessage: "pole wymagane",
        id: "VFRVbl",
      }),
    },
  },

  setPassword: {
    title: defineMessage({
      defaultMessage: "Ustaw hasło",
      id: "5iMeHs",
    }),

    form: {
      labels: {
        password: defineMessage({
          defaultMessage: "Nowe hasło",
          id: "VG3KQt",
        }),
        passwordConfirmation: defineMessage({
          defaultMessage: "Potwierdź nowe hasło",
          id: "deFGRP",
        }),
      },
    },

    buttons: {
      setPassword: defineMessage({
        defaultMessage: "Ustaw hasło",
        id: "5iMeHs",
      }),
    },

    notif: {
      success: defineMessage({
        defaultMessage: "Hasło zostało zresetowane.",
        id: "OG19+4",
      }),
    },

    errors: {
      required: defineMessage({
        defaultMessage: "pole wymagane",
        id: "VFRVbl",
      }),

      passwordConfirmation: defineMessage({
        defaultMessage: "hasła muszą być takie same",
        id: "ZtyZuY",
      }),
    },
  },
};
